import React from 'react';
import {Discount, Money} from '../../../../PulsoidClient';
import css from './PartnerPricingBlock.module.css';
import {formatMoney} from '../../../../utils/moneyUtils';
import {ActionWithProgress} from '../../../../system/buttons';

export type PartnerPricingBlockProps = {
  title: string;
  price: Money;
  discount?: Discount;
  buttonLabel: string;
  onBuyClick: () => void;
};

export const PartnerPricingBlock = (props: PartnerPricingBlockProps) => {
  return (
    <div className={css.root}>
      <>
        <div className={css.info}>
          <div className={css.infoHeader}>
            <span className={css.title}>{props.title}</span>
            {props.discount ? (
              <span className={css.discount}>
                &nbsp;{formatMoney(props.price)}&nbsp;
              </span>
            ) : null}
          </div>
          <div className={css.price}>
            {formatMoney(props.discount ? props.discount?.price : props.price)}
          </div>
        </div>

        <ActionWithProgress
          className={css.button}
          onClick={props.onBuyClick}
          outline
          square
        >
          {props.buttonLabel}
        </ActionWithProgress>
      </>
    </div>
  );
};
